import "../../../assets/RideButton.css";
import t, { forwardRef as N, cloneElement as k } from "react";
import z from "clsx";
import { RideSpinner as F } from "../spinner/RideSpinner.js";
const G = "_fill_11rb4_17", I = "_disabled_11rb4_34", D = "_text_11rb4_40", $ = "_outline_11rb4_78", j = "_small_11rb4_179", q = "_medium_11rb4_179", A = "_large_11rb4_179", H = "_loading_11rb4_245", r = {
  "ride-button": "_ride-button_11rb4_1",
  "full-width": "_full-width_11rb4_14",
  fill: G,
  disabled: I,
  text: D,
  "fill-inverse": "_fill-inverse_11rb4_46",
  outline: $,
  "outline-inverse": "_outline-inverse_11rb4_109",
  "text-primary": "_text-primary_11rb4_140",
  small: j,
  medium: q,
  large: A,
  "x-large": "_x-large_11rb4_179",
  "text-secondary": "_text-secondary_11rb4_183",
  loading: H,
  "glyph-right": "_glyph-right_11rb4_329",
  "glyph-left": "_glyph-left_11rb4_332"
}, J = N(
  ({
    className: x,
    disabled: e,
    fullWidth: v,
    glyph: i,
    glyphPosition: o = "right",
    href: s,
    loading: n,
    size: a = "small",
    target: y = "_blank",
    text: _ = "button",
    type: h = "button",
    variant: u = "fill",
    onClick: m,
    "aria-label": E,
    "data-testid": c,
    ...b
  }, d) => {
    const f = () => z(
      x,
      r["ride-button"],
      r[a],
      r[u],
      {
        [r[`glyph-${o}`]]: i && o,
        [r.disabled]: e,
        [r.loading]: !e && n,
        [r["full-width"]]: v
      }
    ), g = () => ({
      "aria-label": E ?? _,
      "aria-busy": !e && n,
      "aria-disabled": e,
      "aria-live": "polite"
    }), R = (l) => {
      if (e || n) {
        l.preventDefault();
        return;
      }
      typeof m == "function" && m(l);
    }, S = {
      "x-large": "x-large",
      large: "x-large",
      medium: "large",
      small: "medium"
    }, w = () => i ? k(i, {
      size: S[a],
      fill: "currentColor"
    }) : null, B = {
      "x-large": "large",
      large: "large",
      medium: "medium",
      small: "small"
    }, C = () => ["fill", "outline-inverse"].includes(u), p = () => /* @__PURE__ */ t.createElement(t.Fragment, null, w(), /* @__PURE__ */ t.createElement("span", { className: r.text }, _), !e && n && /* @__PURE__ */ t.createElement(
      F,
      {
        size: B[a],
        inverse: C()
      }
    ));
    return /* @__PURE__ */ t.createElement(t.Fragment, null, s ? /* @__PURE__ */ t.createElement(
      "a",
      {
        ...b,
        ...g(),
        ref: d,
        className: f(),
        role: "button",
        href: e ? void 0 : s,
        target: y,
        "data-testid": c
      },
      p()
    ) : /* @__PURE__ */ t.createElement(
      "button",
      {
        ...b,
        ref: d,
        className: f(),
        onClick: (l) => R(l),
        disabled: e,
        type: h,
        ...g(),
        "data-testid": c
      },
      p()
    ));
  }
);
J.displayName = "RideButton";
export {
  J as RideButton
};
